import { useContext } from 'react'

import { AuthContext } from '~/auth/AuthProvider'
import { AbilityContext } from '~/layouts/components/acl/Can'

export const useAuth = () => useContext(AuthContext)
export const useAbility = () => useContext(AbilityContext)
